module.exports = __webpack_public_path__ + "static/media/team.d97ff999.jpg";